import { call, put, takeEvery } from 'redux-saga/effects';
import {
    updateUserAddressFailure,
    updateUserAddressRequest,
    updateUserAddressSuccess
} from './UpdateUserAddressSlice';
import i18next from 'i18next';
import { _API_ENDPOINT, SUCCESS } from '../../constants/AppConstants';
import { _CALLPUTAPI } from '../../api/apiHandler';
import UpdateUserAddressPayload from '../../utils/MyAccount/UpdateUserAddressPayload';

function _UPDATE_USER_ADDRESS(payload) {
    const endpoint =_API_ENDPOINT.UPDATE_USER_ADDRESS;
    return _CALLPUTAPI(endpoint, payload)
        .then(response => response)
        .catch(error => { throw error; });
}

function* updateUserAddressSaga(action) {
    try {
        const updateUserAddressPayload = UpdateUserAddressPayload(action.payload);

        const response = yield call(_UPDATE_USER_ADDRESS, updateUserAddressPayload);

        if (response?.actionStatus?.toUpperCase() === SUCCESS) {
            yield put(updateUserAddressSuccess(response));
        } else {
            yield put(updateUserAddressFailure({
                message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            }));
        }
    } catch (error) {
        yield put(updateUserAddressFailure({ message: error?.message || "Unknown error" }));
    }
}

export default function* watchUpdateUserAddress() {
    yield takeEvery(updateUserAddressRequest.type, updateUserAddressSaga);
}
